import Swiper, {Autoplay, Pagination, Navigation} from "swiper";

class IntroSlider {
    constructor(el) {
        this.el = el;
        this.init();
    }

    init() {
        new Swiper(this.el, {
            slidesPerView: "auto",
            modules: [Pagination, Autoplay, Navigation],
            spaceBetween: 16,
            pagination: {
                el: ".intro__pagination",
                bulletElement: "button",
                clickable: true
            },
            navigation: {
                nextEl: ".js-intro-next",
                prevEl: ".js-intro-prev"
            },
            autoplay: {
                delay: 7000,
                disableOnInteraction: false
            },
        });
    }
}

window.addEventListener("load", function() {
    document
        .querySelectorAll(".js-intro-slider")
        .forEach(slider => new IntroSlider(slider));
});
